import type { PositionRef } from '../../graphpad.model';
import type { ElementContext } from '../element.model';
import { extractExpressionPaths } from '../../context/expression-parser';

/** Resolved coordinate getters for a position */
export type ResolvedPosition = [() => number, () => number];

/**
 * Resolve a position reference to reactive [getX, getY] coordinate getters.
 * Literal numbers become constant thunks; string expressions are resolved via valueContext.
 */
export function resolvePosition(pos: PositionRef, context: ElementContext): ResolvedPosition {
  const { valueContext } = context;
  if (!valueContext) {
    return [() => NaN, () => NaN];
  }
  return [valueContext.createThunk(pos.x), valueContext.createThunk(pos.y)];
}

/**
 * Extract element ID dependencies from a position reference.
 */
export function getPositionDependencies(pos: PositionRef, allElements: Record<string, unknown>): string[] {
  const deps: string[] = [];

  for (const val of [pos.x, pos.y]) {
    if (typeof val === 'string') {
      const paths = extractExpressionPaths(val);
      for (const path of paths) {
        const dotIndex = path.indexOf('.');
        const elementId = dotIndex > 0 ? path.substring(0, dotIndex) : path;
        if (elementId in allElements) {
          deps.push(elementId);
        }
      }
    }
  }

  return deps;
}
